<template>
  <div
    data-sidebar="content"
    :class="
      cn(
        'tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-2 tw-overflow-auto group-data-[collapsible=icon]:tw-overflow-hidden',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/components/ui/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>
